<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  class?: string
}>()

const classes = computed(() => ({
  'app-spinner': true,
  [`${props.class}`]: !!props.class,
}))
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    focusable="false"
    aria-hidden="true"
    fill="none"
    :class="classes"
    class="animate-spin"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
      stroke-opacity="0.1"
    />
    <path
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-spinner {
  width: 1em;
  height: 1em;
  pointer-events: none;
}
</style>
